import React, { Component } from "react";
import { DayPicker } from "react-day-picker";
import moment from "moment";
import "react-day-picker/style.css";

class MyInput extends Component {
  focus = () => {
    this.input.focus();
  };
  render() {
    let { value, onFocus, placeholder, required, readOnly } = this.props;
    return (
      <label className="label-input date">
        {readOnly ? (
          <input
            type="text"
            placeholder=" "
            value={value && value !== "Invalid date" ? value : ""}
            ref={(el) => (this.input = el)}
            readOnly
          />
        ) : (
          <input
            type="text"
            placeholder=" "
            value={value && value !== "Invalid date" ? value : ""}
            ref={(el) => (this.input = el)}
            onClick={onFocus}
            readOnly
          />
        )}
        <span>
          {placeholder} {required && <em className="req">*</em>}
        </span>
      </label>
    );
  }
}

export class DateTime extends Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
  }

  state = {
    daterange: [],
    highlighted: this.props.highlighted ? this.props.highlighted : [],
    isOpen: false,
    selectedDate: this.props.value
      ? (moment(this.props.value, this.props.dateFormat || "DD/MM/YYYY").isValid()
        ? moment(this.props.value, this.props.dateFormat || "DD/MM/YYYY").toDate()
        : null)
      : null,
  };

  componentDidMount() {
    this.updateDateRange(this.state.highlighted);
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.highlighted !== this.props.highlighted) {
      this.updateDateRange(this.props.highlighted);
    }
    if (prevProps.value !== this.props.value) {
      this.updateDateRange(this.state.highlighted);
      // Update selectedDate when value prop changes
      if (this.props.value) {
        const parsedDate = moment(this.props.value, this.props.dateFormat || "DD/MM/YYYY").toDate();
        if (moment(parsedDate).isValid()) {
          this.setState({ selectedDate: parsedDate });
        }
      } else {
        this.setState({ selectedDate: null });
      }
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.highlighted !== state.highlighted) {
      return {
        highlighted: props.highlighted,
      };
    }
    return null;
  }

  updateDateRange = (date) => {
    if (date && date.length === 2) {
      this.setState({
        daterange: [
          {
            after: new Date(moment(date[0]).subtract(1, "days")),
            before: new Date(moment(date[1]).add(1, "days")),
          },
        ],
      });
    }
  };

  handleReset = (e) => {
    if (e) {
      e.stopPropagation();
    }
    this.props.onChange(null);
    this.setState({ selectedDate: null });
  };

  handleClickOutside = (event) => {
    if (this.containerRef.current && !this.containerRef.current.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  };

  handleDaySelect = (day) => {
    if (day) {
      const formattedDate = moment(day).format(this.props.dateFormat || "DD/MM/YYYY");
      this.props.onChange(formattedDate);
    }
    this.setState({ isOpen: false });
  };

  render() {
    const { isOpen, daterange } = this.state;
    const { label, required, readOnly, fromDate } = this.props;
    const dateFormat = this.props.dateFormat || "DD/MM/YYYY";

    return (
      <div ref={this.containerRef} style={{ position: "relative" }}>
        <MyInput
          value={
            this.state.selectedDate
              ? moment(this.state.selectedDate).format(dateFormat)
              : ""
          }
          placeholder={label}
          required={required}
          readOnly={readOnly}
          onFocus={() => !readOnly && this.setState({ isOpen: true })}
        />

        {isOpen && !readOnly && (
          <div className="day-picker-container" style={{width: 245, position: "absolute", top: "103%", left: 0, zIndex: 9999, background: "white", border: "1px solid #ccc", borderRadius: "4px", padding: "10px" }}>
            <DayPicker
              mode="single"
              selected={this.state.selectedDate}
              onSelect={(day) => {
                this.setState({ selectedDate: day });
                this.props.onChange(day);
                this.setState({ isOpen: false });
              }}
              defaultMonth={this.state.selectedDate || fromDate || new Date()}
              modifiers={{
                booked: {
                  from: daterange[0]?.after || null,
                  to: daterange[0]?.before || null,
                },
              }}
              modifiersClassNames={{
                booked: "my-booked-class",
              }}
            />
            <div className="day-picker-footer text-center border-top pt-2" onClick={(e) => e.stopPropagation()}>
              <button className="day-picker-footer-button btn btn-sm btn-outline-primary px-3 py-1" onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.handleReset(e); }}>Clear</button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default DateTime;
